import React from "react";
import { Root } from "./style";

interface LineProps {}

export const Line: React.FC<LineProps> = (props) => {
  return <Root />;
};
